<ng-container *transloco="let t">
  <!-- Header: dashboard -->
  <nav
    class="legal-terms_nav"
    *ngIf="!isPublic">
    <h2 [innerHTML]="t('legal-terms.title')"></h2>
    <app-tabs>
      <ul class="tabs">
        <li
          class="tabs_tab"
          uiSrefActive="__active">
          <a
            class="tabs_tab_title"
            uiSref="legal-terms"
            [uiParams]="{ document: 'privacy-policy' }"
            [innerHTML]="t('common.privacy-policy')"></a>
        </li>
        <li
          class="tabs_tab"
          uiSrefActive="__active">
          <a
            class="tabs_tab_title"
            uiSref="legal-terms"
            [uiParams]="{ document: 'terms-of-use' }"
            [innerHTML]="t('common.terms-of-use')"></a>
        </li>
        <li
          class="tabs_tab"
          uiSrefActive="__active">
          <a
            class="tabs_tab_title"
            uiSref="legal-terms"
            [uiParams]="{ document: 'imprint' }"
            [innerHTML]="t('common.imprint')"></a>
        </li>
      </ul>
    </app-tabs>
  </nav>

  <ng-container *ngIf="isLoaded; else loaderBlock">
    <div
      class="legal-terms"
      [ngClass]="isPublic ? '__public' : '__dashboard'">
      <!-- Header: public -->
      <div
        class="legal-terms_header"
        *ngIf="isPublic">
        <h1
          class="legal-terms_header_title"
          [innerHTML]="t('legal-terms.' + document, { customerName: companyName })"></h1>
        <span
          class="legal-terms_header_lastupdate"
          *ngIf="document !== 'imprint'"
          [innerHTML]="t('legal-terms.lastupdate', { lastUpdate: lastUpdate })"></span>
      </div>

      <!-- Body -->
      <div class="legal-terms_body">
        <app-table-of-contents>
          <div
            class="legal-terms_body_document"
            [innerHTML]="documentContents"></div>
        </app-table-of-contents>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #loaderBlock>
  <app-icon
    class="layout_spinner"
    name="spinner"></app-icon>
</ng-template>
